import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEventName } from '@/api/analytics';
import { Button } from '@/components/buttons';
import { Locale } from '@/helpers/languages';
import { Modals } from '@/helpers/modals';
import { useAnalytics } from '@/hooks/analytics';
import { useCommonStore, useModalsStore } from '@/store';

import { ScAuthButton } from './styled';

export const AuthButtons = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const open = useModalsStore.use.open();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const { sendEventToAnalytics } = useAnalytics();

  const handleRegisterClick = () => {
    if (!isMobileDevice) {
      sendEventToAnalytics({ name: AnalyticsEventName.REG_BUTTON_TOP });
    }

    open(Modals.Registration);
  };

  const handleLoginClick = () => {
    if (!isMobileDevice) {
      sendEventToAnalytics({ name: AnalyticsEventName.LOG_IN_TOP });
    }
    open(Modals.Login);
  };

  const btnProps = useMemo(() => {
    const paddingX = [
      Locale.GERMAN,
      Locale.FRENCH_CANADA,
      Locale.FRENCH_SWITZERLAND,
    ].includes(language as Locale)
      ? 8
      : 16;
    return isMobileDevice ? { paddingX } : {};
  }, [isMobileDevice, language]);

  return (
    <>
      <ScAuthButton>
        <Button
          id="loginButton"
          small
          secondary
          wide
          onClick={handleLoginClick}
          {...btnProps}
        >
          {t('button.login')}
        </Button>
      </ScAuthButton>
      <ScAuthButton>
        <Button
          id="registerButton"
          small
          primary
          wide
          onClick={handleRegisterClick}
          {...btnProps}
        >
          {t('button.register')}
        </Button>
      </ScAuthButton>
    </>
  );
};
